import { Route, Routes } from '@angular/router';
import { PageTypeEnum } from './enums/page-type.enum';
import {
  AccountCustomerInfoComponent,
} from './pages/account-page/components/account-customer-info/account-customer-info.component';
import { AccountOrdersComponent } from './pages/account-page/components/account-orders/account-orders.component';
import { WishlistComponent } from './pages/account-page/components/wishlist/wishlist.component';
import { AccountDiscountComponent } from './pages/account-page/components/account-discount/account-discount.component';
import { BLOG_ROUTE_PREFIX, RU_ROUTE_PREFIX, UA_ROUTE_PREFIX } from './constants';
import { inject } from '@angular/core';
import { VanillaRoutingService } from './services/vanilla-routing.service';


export const DUMMY_ROUTE: Route = {
  path: 'dummy',
  children: [
    {
      path: PageTypeEnum.Product,
      loadComponent: () => import('./pages/product-page/product-page.component').then(c => c.ProductPageComponent),
    },
    {
      path: PageTypeEnum.Category,
      loadComponent: () => import('./pages/category-page/category-page.component').then(c => c.CategoryPageComponent),
    },
    {
      path: PageTypeEnum.BlogCategory,
      loadComponent: () => import('./pages/blog/blog-category-page/blog-category-page.component').then(c => c.BlogCategoryPageComponent),
    },
    {
      path: PageTypeEnum.BlogPost,
      loadComponent: () => import('./pages/blog/blog-post-page/blog-post-page.component').then(c => c.BlogPostPageComponent),
    },
  ],
};

export const STATIC_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/index-page/index-page.component').then(c => c.IndexPageComponent),
  },
  {
    path: 'account',
    loadComponent: () => import('./pages/account-page/account-page.component').then(c => c.AccountPageComponent),
    children: [
      { path: '', pathMatch: 'full', component: AccountCustomerInfoComponent, data: { label: 'global.contacts' } },
      { path: 'orders', component: AccountOrdersComponent, data: { label: 'global.my_orders' } },
      { path: 'wishlist', component: WishlistComponent, data: { label: 'global.my_wishes' } },
      // { path: 'reviews', component: AccountReviewsComponent, data: { label: 'account_reviews.my_reviews' } },
      { path: 'discount', component: AccountDiscountComponent, data: { label: 'global.my_discounts' } },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login-page/login-page.component').then(c => c.LoginPageComponent),
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout-page/checkout-page.component').then(c => c.CheckoutPageComponent),
  },
  {
    path: 'order-success',
    loadComponent: () => import('./pages/order-success-page/order-success-page.component').then(c => c.OrderSuccessPageComponent),
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/cart-page/cart-page.component').then(c => c.CartPageComponent),
  },
  {
    path: 'oauth-success',
    loadComponent: () => import('./pages/oauth-success-page/oauth-success-page.component').then(c => c.OauthSuccessPageComponent),
  },
  {
    path: 'skidki',
    loadComponent: () => import('./pages/info-pages/discounts-page/discounts-page.component').then(c => c.DiscountsPageComponent),
  },
  {
    path: 'dostavka-i-oplata',
    loadComponent: () => import('./pages/info-pages/shipment-payment-page/shipment-payment-page.component').then(c => c.ShipmentPaymentPageComponent),
  },
  {
    path: 'vozvrat-tovara',
    loadComponent: () => import('./pages/info-pages/repayments-page/repayments-page.component').then(c => c.RepaymentsPageComponent),
  },
  {
    path: 'contacts',
    loadComponent: () => import('./pages/info-pages/contacts-page/contacts-page.component').then(c => c.ContactsPageComponent),
  },
  {
    path: 'politika-konfidencialnosti',
    loadComponent: () => import('./pages/info-pages/policy-page/policy-page.component').then(c => c.PolicyPageComponent),
  },
  {
    path: 'pg-gilding-tools-and-materials',
    loadComponent: () => import('./pages/info-pages/pg-page/pg-page.component').then(c => c.PgPageComponent),
  },
  {
    path: 'otzyvy',
    loadComponent: () => import('./pages/store-reviews-page/store-reviews-page.component').then(c => c.StoreReviewsPageComponent),
  },
  {
    path: 'search',
    loadComponent: () => import('./pages/search-page/search-page.component').then(c => c.SearchPageComponent),
  },
  {
    path: 'order-payment-details',
    loadComponent: () => import('./pages/order-payment-details-page/order-payment-details-page.component').then(c => c.OrderPaymentDetailsPageComponent),
  },
];

export const buildBlogRoute: () => Route = (): Route => ({
  path: BLOG_ROUTE_PREFIX,
  children: [
    {
      path: '',
      pathMatch: 'full',
      loadComponent: () => import('./pages/blog/blog-page/blog-page.component').then(c => c.BlogPageComponent),
    },
  ],
});

const NOT_FOUND_ROUTE: Route = {
  path: '**',
  loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(c => c.NotFoundPageComponent),
  canActivate: [() => !inject(VanillaRoutingService).isVanillaRoutingInProgress],
};

export const buildAllRoutes = (blogRoute: Route, dynamicRoutes: Routes): Routes => {
  const childrenRoutes: Routes = [...STATIC_ROUTES, blogRoute, ...dynamicRoutes];
  const RU_ROUTE: Route = {
    path: RU_ROUTE_PREFIX,
    children: childrenRoutes,
  };

  const UK_ROUTE: Route = {
    path: UA_ROUTE_PREFIX,
    children: childrenRoutes,
  };

  return [
    RU_ROUTE,
    UK_ROUTE,
    NOT_FOUND_ROUTE,
  ];
};
